import React, { useMemo } from 'react'
import { useFormConfigContext } from './hooks/useFormConfig';
import { stripTabKeyFromOptions } from 'src/utils/era-package/tab-utils'
import { Typography } from '@mui/material';


const ErrorComponent = ({ error }) => {
  if (!!error)
    return <Typography color='error' variant='body2'>{error}</Typography>
  return <></>
}
export const RenderArrayField = ({ section, tabKey, optionsMap, readOnly }) => {
  const formCtx = useFormConfigContext() || null

  const data = useMemo(
    () => !!formCtx
      ? formCtx.getValues(section.name) || []
      : section.tableData,
    [formCtx, section.name, section.tableData]
  )

  const handleInput = data => {
    if (!!formCtx)
      formCtx.setValue(section.name, data)
    if (!!section.onTableDataChange)
      section.onTableDataChange(data)
  }

  // Render table section
  const TableComponent = section.tableComponent;
  return (<>
    <TableComponent
      title={section.title}
      fields={section.tableFields}
      name={section.name}
      error={<ErrorComponent error={formCtx?.getError(section.name)} />}
      optionsMap={stripTabKeyFromOptions(optionsMap, tabKey)}
      data={data} tabKey={tabKey}
      onDataChange={handleInput}
      maxRows={section.maxRows}
      onUploadSuccess={section.onUploadSuccess}
      handleApiCall={section.handleApiCall}
      handleRefresh={section.handleRefresh}
      handleClearAll={section.handleClearAll}
      filesUnderProcessing={section.filesUnderProcessing}
      handleDeleteRow={section.handleDeleteRow}
      disableEdit={section.disableEdit || readOnly}
      onRowClick={section.onRowClick} // Pass through the onRowClick prop
      uploadFormComponent={section.uploadFormComponent}
      onUpload={section.onUpload}
      allowDownload={section.allowDownload}
      handleDownload={section.handleDownload}
    />
  </>);
}